import {
  ChangePassword,
  HasReadRules,
  IsComplatedInformation,
  Login,
  Register,
  SendCode,
  UpdateFurtherinformation,
  updateProfile,
  VerifyTokenT,
} from "@interfaces/auth";
import {
  AddOrder,
  Bill,
  OnlineCourse,
  PendingOrder,
  UserAllCourseAndPackage,
} from "@interfaces/basket";
import { RequestSettlement, VerifySettlement } from "@interfaces/credit";
import { SendComment } from "@interfaces/details";
import { RulesMain } from "@interfaces/index";
import {
  ActivityProgress,
  SendPractice,
  Sessions,
  SkyRoom,
} from "@interfaces/sessions";
import {
  PayWithMultipleSegment,
  SumTransactionOfUser,
  TransactionsEachUserWithCoin,
} from "@interfaces/transaction";

import api from "./api";

const uploadFile = {
  uploadFile: (
    data: FormData,
    onUploadProgress: ((progressEvent: any) => void) | undefined
  ) => api.file("FileManager/api/File/AddFiles", data, onUploadProgress),
  uploadProfilePic: (
    data: FormData,
    onUploadProgress?: ((progressEvent: any) => void) | undefined
  ) => api.file("Idp/Profile/UploadImage", data, onUploadProgress),
};

const home = {
  home: () => api.get("/academy/api/Main/MainTest"),
  getJudgmentFile: () => api.get("/academy/api/Main/GetJudgmentFile"),
  getRecommendedEntity: () => api.get("academy/api/Home/RecommendedEntity"), // دوره ها و بسته ها برای صفحه faq نیاز به لاگین
  getRecommendedEntityMain: () => api.get("academy/api/Main/RecommendedEntity"), // دوره ها و بسته ها برای صفحه faq بدون لاگین
  getProductDetails: ({ id }: { id: number | string }) =>
    api.get(`Product/api/Product/GetProductById/${id}`),
  recommendedEntityForJob: () =>
    api.get("/academy/api/Main/RecommendedEntityForJob"),
};
const search = {
  search: (data: any) => api.get("/academy/api/Main/Search", data),
  studentPageSearch: (query: string) =>
    api.get(`academy/api/Home/SearchDashboard/${query}`),
  wallet: () => api.get("/academy/api/Basket/Wallet"),
  searchInput: () => api.get("/academy/api/Main/SearchInput"),
  searchAdvance: (data: any) =>
    api.post("/academy/api/Main/AdvanceSearch", data),
  searchAdvanceWithPagination: (data: any) =>
    api.post("/academy/api/Main/AdvanceSearchWithPagination", data),
};

const basket = {
  orders: () => api.get("/academy/api/Basket/Order"),
  ordersWithCode: (data: {
    code: string;
    isInstallment: boolean;
    hasInvitationCode: boolean;
  }) => api.post("/academy/api/Basket/Order", data),
  installmentOrders: (isInstallment: boolean) =>
    api.get(`/academy/api/Basket/Order/${isInstallment}`),
  bill: (data: Bill) => api.post(`academy/api/Basket/Bill`, data),
  invoice: (id: number | string, isCancel: boolean, isAdmin: boolean) =>
    api.post("academy/api/Basket/Invoice", {
      id,
      isCancel,
      isAdmin,
    }),
  orderList: (code?: string) =>
    api.get(`academy/api/Basket/PendingOrder${code ? "/" + code : ""}`),
  orderListPost: (data: PendingOrder) =>
    api.post(`academy/api/Basket/PendingOrder`, data),
  deleteOrder: (id: number) => api.delete(`academy/api/Basket/OrderItem/${id}`),
  addOrder: (data: AddOrder) => api.post("academy/api/Basket/OrderItem", data),
  orderWithoutPay: (data: PendingOrder) =>
    api.post("academy/api/Basket/OrderWithoutPay", data),
  paymentResult: ({ token }: { token: string }) =>
    api.get(`/PaymentGateway/api/Payment/GetPaymentResult?token=${token}`),
  calculateDadcoin: (data: { amount: number; orderId: number }) =>
    api.post(`/academy/api/Basket/CaculateDadCoinV2`, data),
  getUserAllCourseAndPackageV3: () =>
    api.get<{ data: { output: UserAllCourseAndPackage } }>(
      `/academy/api/Basket/UserAllCourseAndPackageV3`
    ),
  getUserPackageCoursesV3: (id: number) =>
    api.get<{ data: { courses: any } }>(
      `/academy/api/Basket/UserPackageCoursesV3?packageId=${id}`
    ),
  getOnlineCourses: () =>
    api.get<{ data: { output: OnlineCourse[] } }>(
      `/academy/api/Basket/OnlineCourses`
    ),
  addToArchive: (data: { id: number; entityType: number }) =>
    api.post("academy/api/Basket/AddToArchive", data),
  deleteFromArchive: (data: { id: number; entityType: number }) =>
    api.delete("academy/api/Basket/DeleteFromArchive", data),
  searchDashboard: (data: { query: string }) =>
    api.post(`academy/api/Basket/SearchDashboard`, data),
  getPaymentGateWays: (amount: string | number) =>
    api.post(`paymentgateway/api/Payment/GetPaymentGateways?amount=${amount}`),
  isValidForSnapPay: (amount: string | number) =>
    api.post(`/paymentgateway/api/Payment/SnapPayIsEligible?amount=${amount}`),
};

const articles = {
  articles: (query: string) => api.get(`academy/api/Main/SearchArticle`, query),
  articleDetail: (id: number) =>
    api.get(`academy/api/Main/ArticleDetail/${id}`),
  article: (id: number | any) => api.get(`academy/api/Post/GetDetail/${id}`),
  articleCommentSend: (data: SendComment) =>
    api.post(`academy/api/Main/Comment`, data),
  getSuperior: (id: number | any) =>
    api.get(`academy/api/Post/GetSuperior/${id}`),
  getSearch: (data: {
    search: string;
    pageSize: number;
    pageNumber: number;
    fieldSearchs: [
      {
        fieldName: string;
        text: string;
      }
    ];
  }) => api.post(`academy/api/Post/GetSearch`, data),
  getRecommended: () => api.get(`academy/api/Post/GetRecommended`),
};
const credit = {
  getCreditBalance: () => api.get(`Wallet/api/Credit/BalanceV2`),
  inQuerySettlement: (data: RequestSettlement) =>
    api.post(`Wallet/api/Credit/InQuerySettelmentV2`, data),
  requestSettlement: (data: RequestSettlement) =>
    api.post(`Wallet/api/Credit/RequestSettelmentV2`, data),
  verifySettlement: (data: VerifySettlement) =>
    api.post(`Wallet/api/Credit/VerifySettelmentV2`, data),
};
const wallet = {
  getTransactionsEachUserWithCoin: (data: TransactionsEachUserWithCoin) =>
    api.post(`Wallet/api/Transaction/TransactionsEachUserWithCoin`, data),
  getSumTransactionOfUser: (data: SumTransactionOfUser) =>
    api.post(`Wallet/api/Transaction/SumTransactionOfUser`, data),
  payWithMultipleSegment: (data: PayWithMultipleSegment) =>
    api.post(
      `Wallet/api/PrePurchaseInformation/PayWithMultipleSegmentV2`,
      data
    ),
};
const invitation = {
  getReferralCode: () => api.get(`academy/api/Invitation/ReferralCode`),
};
const packages = {
  packageDetail: (id: number | any) =>
    api.get(`academy/api/Main/packageDetail/${id}`),
  packageDetailInstallment: (id: number | any) =>
    api.get(`academy/api/Home/PackageDetailInstallment/${id}`),
  packagesCommentSend: (data: SendComment) =>
    api.post(`academy/api/Main/PackageComment`, data),
};
const detail = {
  detail: (id: number | any) => api.get(`academy/api/Main/CourseDetail/${id}`),
  sendComment: (data: SendComment) =>
    api.post(`academy/api/Main/CourseComment`, data),
};
const about = {
  about: () =>
    api.get(`Cms/api/Content/GetByName?name=DadbanAboutUs`, null, {
      "x-clientid": "d6be0366-c762-4f2b-a2b3-43c9a308f3e2",
    }),
};
const teacher = {
  teacherDetails: (id: number) =>
    api.get(`academy/api/Main/TeacherDetail/${id}`),
};
const auth = {
  register: (data: Register) =>
    api.post("/Idp/UserRegistration/RegisterUser", data),
  sendCode: (data: SendCode) =>
    api.post("/Idp/Account/Login/PasswordLessWithProfile", data),
  changePass: (data: ChangePassword) =>
    api.post("/Idp/UserRegistration/ChangePassword", data),
  login: (data: Login) => api.post("/Idp/Account/Login", data),
  captcha: () => api.get("Idp/Account/GenerateCaptcha"),
  sendCaptcha: (data: any) => api.get("Idp/Account/SendVerifyCode", data),
  verifyToken: (data: VerifyTokenT) =>
    api.post("/Idp/Account/SendVerfyToken", data),
  profile: (data?: { peopleId: string }) =>
    api.get("/People/api/People/GetById", data),
  loginFromApp: (data: { token: string }) =>
    api.post("/idp/Account/InteractiveToken", data),
};

const session = {
  session: (id: number) => api.get(`academy/api/Home/SessionDetail/${id}`),
  sessions: (data: Sessions) =>
    api.post(`academy/api/Main/SessionDetails`, data),
  skyRoomUrl: (data: SkyRoom) => api.post(`/academy/api/Home/LoginUrl`, data),
  sendPractice: (data: SendPractice) =>
    api.post(`/academy/api/Home/UserPractice`, data),
  activityProgress: (data: ActivityProgress) =>
    api.post(`/academy/api/Home/ActivityProgress`, data),
};
const student = {
  rules: () => api.get(`academy/api/Home/HasReadRules`),
  mainInput: () => api.get(`academy/api/RuleAndRegulation/MainInput`),
  mainRules: (data: RulesMain) =>
    api.post(`academy/api/RuleAndRegulation/MainV2`, { ...data }),
  sendIsReadRules: (data: HasReadRules) =>
    api.post(`academy/api/Home/HasReadRules`, data),
  userCourses: (data: {
    search: string;
    pageSize: number;
    pageNumber: number;
    fieldSearchs: [
      {
        fieldName: string;
        text: string;
      }
    ];
  }) => api.post(`academy/api/Home/UserCourses`, data),
  dashboard: () => api.get(`academy/api/Home/UserDashboard`),
  userAllCourses: (data: {
    search: string;
    pageSize: number;
    pageNumber: number;
    fieldSearchs: [
      {
        fieldName: string;
        text: string;
      }
    ];
  }) => api.post(`academy/api/Home/UserAllCourses`, data),
  updateFurtherinformation: (data: UpdateFurtherinformation) =>
    api.put(`People/api/People/BaseUpdatePeople`, data),
  isComplatedInformation: (data: IsComplatedInformation) =>
    api.put(`academy/api/Home/FurtherInformation`, data),
  updateProfile: ({
    email,
    firstName,
    lastName,
    invitationCode,
    id,
    header,
  }: updateProfile) =>
    api.post(
      `Idp/Profile`,
      { email, firstName, lastName, invitationCode, id },
      header
    ),
  updateUserProfile: ({
    firstName,
    lastName,
    invitationCode,
    id,
    header,
  }: updateProfile) =>
    api.post(
      `Idp/Profile`,
      { firstName, lastName, invitationCode, id },
      header
    ),
  userCoursesStatus: (data: { CourseId: number; CourseStatus: number }) =>
    api.put(
      `academy/api/Home/UserCourseStatus?CourseId=${data.CourseId}&CourseStatus=${data.CourseStatus}`
    ),
};

const profile = {
  deleteProfilePicture: () => api.delete("Idp/Profile/RemoveImage"),
};

const advertising = {
  jobsHome: (data: any) => api.post("/academy/api/Advertising/JobHome", data),
  newAdvertisings: () => api.get("/academy/api/Advertising/GetNewAdvertisings"),
  jobGetById: (id: string | undefined) =>
    api.get(`/academy/api/Advertising/GetById?Id=${id}`),
  jobsSearchInput: (data: { searchField: string; searchValue: string }) =>
    api.post(
      `/academy/api/Advertising/SearchInput?SearchField=${data.searchField}&SearchValue=${data.searchValue}`
    ),
};
const airSheet = {
  createUserActivity: (data: {
    campaignId: string | string[] | number;
    followUpId: string | string[] | number;
    phoneNumber: string | string[];
    type: number;
    url: string;
    isPromotion: boolean;
  }) => api.post("bizschool/api/Campaign/AddUserActivity", data),
};

const guestSessions = {
  guestSessionDetail: (sessionId: string | number) =>
    api.get(`/academy/api/v1/guest-sessions/${sessionId}/detail`),
  guestSessionView: (sessionId: string | number) =>
    api.post(`/academy/api/v1/guest-sessions/${sessionId}/view`),
  guestSessionJoin: (
    sessionId: string | number,
    data: { firstName: string; lastName: string; phoneNumber: string }
  ) => api.post(`/academy/api/v1/guest-sessions/${sessionId}/join`, data),
};

export default {
  ...uploadFile,
  ...home,
  ...teacher,
  ...packages,
  ...auth,
  ...search,
  ...detail,
  ...about,
  ...articles,
  ...session,
  ...student,
  ...basket,
  ...profile,
  ...credit,
  ...wallet,
  ...invitation,
  ...advertising,
  ...airSheet,
  ...guestSessions,
};
